import React from "react";
import "./Contactform.css";
import HubspotForm from "react-hubspot-form";
import $ from "jquery";
export default class Contactform extends React.Component {
    constructor(props) {
        super(props);
        this.toggleme = this.toggleme.bind(this);
        this.toggle = this.toggle.bind(this);
        this.state = {
            tooltipOpen: false
        };
        this.baseState = this.state
    }
    toggleme() {
        alert("toggleme pressed");
    }
    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    resetForm = () => {
        this.setState(this.baseState)
    }
    componentDidMount() {
        setTimeout(function () {
            var large =
                '<span class="tooltip1">Terms and Conditions<span class="tooltiptext1">Certified Integrator is committed to protecting and respecting your privacy, and we’ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to say how you would like us to contact you:<br> By clicking submit below, you consent to allow Certified Integrator to store and process the personal information submitted above to provide you the content requested.<br>I agree to allow Certified Integrator to store and process my personal data.</span></span>';

            $(large).insertAfter(
                "#reactHubspotForm0 .hs-form-booleancheckbox label span"
            );
        }, 7000);
    }
    render() {
        return (
            <div id="contactform" className="contactform-wrapper hubspot-wrapper hubspot">
                <div className="hubspot-container">

                    <HubspotForm
                        id="hubspotForm"
                        className="d-block mx-auto"
                        portalId="2277117"
                        formId="e31cacbb-95d8-4dde-aeea-7df24ccdc146"
                        onFormSubmit={() => console.log("Submit!")}
                        onReady={this.resetForm}
                        loading={<div className="text-center">Loading...</div>}
                        onClick={this.toggleme}
                    />
                </div>
            </div>
        );
    }
}
